import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDungeon, faFistRaised, faCalendarDay, faBookDead, faHatWizard, faHourglass, faScroll } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import Username from './../common/Username';
import Avatar from './../common/Avatar';
import Moment from 'react-moment';

const ActivityFeedDKPEvent = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> concluded an event,</span>
                <h4>
                    <FontAwesomeIcon className="text-primary" icon={faDungeon} fixedWidth />
                    <Link to={"/dkp/events/" + props.item.dkpEvent.slug}> {props.item.dkpEvent.location.map((loc) => loc.title).join(", ")}</Link>
                </h4>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faFistRaised} fixedWidth /> Raid Leader: <Username user={props.item.dkpEvent.eventLeaderDetail} rank={props.ranks[props.item.dkpEvent.eventLeaderDetail.rank]} />
                </div>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faCalendarDay} fixedWidth /> <Moment format="MMM D YYYY h:mm A">{props.item.dkpEvent.started}</Moment>
                </div>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faBookDead} fixedWidth /> Kills: <span className="text-primary">{props.item.dkpEvent.entities.length}</span>
                </div>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> Items: <span className="text-primary">{props.item.dkpEvent.awardedItems.length}</span>
                </div>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faHourglass} fixedWidth /> DKP per hour: <span className="text-primary">{props.item.dkpEvent.dkp}</span>
                </div>
                <div>
                    <FontAwesomeIcon className="text-primary" icon={faScroll} fixedWidth /> DKP earned: <span className="text-primary">{
                        (
                            props.item.dkpEvent.dkp * (new Date(props.item.dkpEvent.stopped).getTime() - new Date(props.item.dkpEvent.started).getTime()) / (3600 * 1000)
                            + props.item.dkpEvent.entities.reduce((total, entity) => total + parseFloat(entity.dkp), 0)
                        ).toFixed(2)
                    }</span><span className="activity-date text-muted"> in </span><span className="text-primary">{((new Date(props.item.dkpEvent.stopped).getTime() - new Date(props.item.dkpEvent.started).getTime()) / (3600 * 1000)).toFixed(1)}</span><span className="activity-date text-muted"> hours</span>
                </div>
            </div>
        </div>
    </li>
);

export default ActivityFeedDKPEvent;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedDKPEvent.js